import React from "react"

import classNames from "classnames/bind"
import styles from "../styles/Loading.module.scss"
import { withTranslation } from "react-i18next"
import "../i18n/i18n"

import { withRouter } from "react-router-dom"

class Loading extends React.Component {
  componentDidMount() {
    const { history } = this.props

    setTimeout(() => {
      history.push("/result")
    }, 3000)
  }

  render() {
    const { t } = this.props

    return (
      <div className={cn("contents")}>
        <img src="images/loading.gif" className={cn("loading-video")} alt="분석 중.." />

        {/* <video className={cn("loading-video")} playsInline muted autoPlay loop>
          <source src="./images/loading.mp4" type="video/mp4" />
        </video> */}
        <span className={cn("loading-text")}>{t("analyzing")} …</span>
      </div>
    )
  }
}

const cn = classNames.bind(styles)

export default withRouter(withTranslation()(Loading))
